import { getShouldOverrideToSortBySizeForMailFolder } from 'owa-mail-folder-store';
import createMailFolderTableQuery from 'owa-mail-triage-table-utils/lib/createMailFolderTableQuery';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { updateWatermarksAndResetRollup } from 'owa-mail-focused-inbox-rollup-store';
import loadTableViewFromTableQuery from '../actions/loadTableViewFromTableQuery';
import { orchestrator } from 'satcheljs';
import { selectFocusedViewFilter, getTableViewFromTableQuery } from 'owa-mail-triage-table-utils';
import { resetFocus } from 'owa-mail-focus-manager';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { lazyCreateSuggestedUnsubscribeItems } from 'owa-mail-suggested-unsubscribe-store';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { setLastAutoFocusedRowKey } from 'owa-mail-list-selection-actions-v2/lib/mutators/setLastAutoFocusedRowKey';
import type { TableView } from 'owa-mail-list-store';
import {
    setCopilotResultsTableViewIdsMutator,
    getStore as getListViewStore,
    getPreviousTableViewId,
    isCopilotResultsTable,
} from 'owa-mail-list-store';

orchestrator(selectFocusedViewFilter, async actionMessage => {
    const focusedViewFilterToSelect = actionMessage.focusedViewFilter;
    let selectedTableView: TableView | undefined = getSelectedTableView();

    // If the Copilot Results tab is currently selected, we want to switch the selectedTableView
    // to the previous table view so that when we update the focused view filter and reload,
    // we are reloading the correct table view (instead of the Copilot Results table view).
    if (isCopilotResultsTable(selectedTableView?.tableQuery)) {
        const previousTableViewId = getPreviousTableViewId();
        selectedTableView = previousTableViewId
            ? getListViewStore().tableViews.get(previousTableViewId) ?? undefined
            : undefined;
    }

    if (!selectedTableView) {
        return;
    }

    const mailboxInfo = getMailboxInfo(selectedTableView);

    // Update last visit watermark for selected pivot and reset rollup data
    updateWatermarksAndResetRollup(focusedViewFilterToSelect, 'NonUserAction', mailboxInfo);

    // Always reset the view filter when user switches the focused pivot
    const shouldOverrideToSortBySize: boolean = getShouldOverrideToSortBySizeForMailFolder();
    const tableQuery = createMailFolderTableQuery(
        selectedTableView.tableQuery.folderId,
        selectedTableView.tableQuery.listViewType,
        shouldOverrideToSortBySize ? 'mailFolderSortBySize' : 'mail',
        focusedViewFilterToSelect,
        undefined /* viewFilter */,
        undefined /* categoryName */,
        undefined /* sortBy */
    );

    const loadTableViewPromise = await loadTableViewFromTableQuery(tableQuery);
    const tableView = getTableViewFromTableQuery(tableQuery);

    // Only update the previousTableViewId because we want to return to the same table if the Copilot Results tab
    // is dismissed after switching pivots. The tableViewId for the Copilot Results tab is already set when the tab is
    // created in loadReferenceListIntoTable and should not be overridden here.
    setCopilotResultsTableViewIdsMutator(
        undefined /* copilotResultsTableViewId */,
        tableView.id /* previousTableViewId */
    );

    // If the user switches to the Other pivot, fetch suggested unsubscribe items
    if (isConsumer(undefined /* smtpAddress */, mailboxInfo) && focusedViewFilterToSelect == 1) {
        lazyCreateSuggestedUnsubscribeItems.importAndExecute(tableView);
    }

    resetFocus('selectFocusViewFilter');
    setTimeout(() => {
        const currentlySelectedTableView = getSelectedTableView();
        if (currentlySelectedTableView) {
            setLastAutoFocusedRowKey(selectedTableView, '');
        }
    }, 0);

    return loadTableViewPromise;
});
